import { mq, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { Z_INDEX } from "~/styles/z-index";

export const DivPlayPositionCenter = styled.div<{ isPlayBtnDisplay: boolean }>`
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity, 0.5s ease-in-out, visibility 0.5s ease-in-out;
  z-index: ${Z_INDEX.HEADER - 5};

  ${({ isPlayBtnDisplay }) =>
    isPlayBtnDisplay &&
    `
      visibility: visible;
      opacity: 1;
    `}
`;

export const ParText = styled.p`
  font-weight: ${FONT_WEIGHT.BOLD};
  margin-top: 8px;
  font-size: 24px;
  word-break: keep-all;

  ${mq.sp} {
    font-size: ${FONT_SIZE.L}px;
  }
`;
